import axios from './axios-instance';

// 获取通知消息
export function queryNotification(params) {
  return axios.get('/ops/auth/notice/center', { params });
}

// 设为已读
export function updateNotificationStatus(params) {
  return axios.get('/ops/auth/notice/center/read', {
    params,
  });
}

// 获取日志
export function queryOperationLog(params) {
  return axios.get('/brand-thirdremote/sys-changes-log/latest', {
    params,
    headers: {
      type: 'brand',
    },
  });
}

// 日志是否已读
export function getOperationLogStatus(params) {
  return axios.get('/brand-thirdremote/sys-changes-log/read-statu-latest', {
    params,
    headers: {
      type: 'brand',
    },
  });
}
